// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2kU20","notes":"Notes_notes__1G_5o"};